import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './layouts/Layout';
import HomePage from './pages/HomePage';
import ScheduleAppointmentPage from './pages/ScheduleAppointmentPage';
import OnlineCoursePage from './pages/OnlineCoursePage';
import UnderConstructionPage from './pages/UnderConstructionPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UnderConstructionPage />} />
        <Route
          path="/sample"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />
        <Route
          path="/schedule-appointment"
          element={
            <Layout>
              <ScheduleAppointmentPage />
            </Layout>
          }
        />
        <Route
          path="/online-course"
          element={
            <Layout>
              <OnlineCoursePage />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
